import {
  LandingFormsListItem,
  ModelsLandingFormType1 as LandingFormType,
} from '@/shared/api/topli/TopliApi'
import { Link } from 'react-router-dom'

export const eventTypeColors = {
  1: 'blue',
  2: 'violet',
}

export const getDetails = (item: LandingFormsListItem): JSX.Element => {
  const formType = item.form_type

  if (formType === LandingFormType.Feedback) {
    const parts: string[] = []

    if (item.district) parts.push(item.district)
    if (item.bedrooms) parts.push(String(item.bedrooms))

    if (item.price_from) {
      parts.push(`from ${item.price_from} ${item.currency}`)
    }
    if (item.price_to) {
      parts.push(`to ${item.price_to} ${item.currency}`)
    }

    const text = parts.join(', ')

    return <span>{text || '-'}</span>
  }

  if (formType === LandingFormType.Info && item.residential_id && item.residential_name) {
    return (
      <Link
        className='text-sm font-medium text-blue hover:underline underline-offset-4'
        to={`/projects/${item.residential_id}`}
        target='_blank'
      >
        {item.residential_name}
      </Link>
    )
  }

  return <span>-</span>
}
